/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDataExportsForOrgSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListDataExportsForOrgRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListDataExportsForOrgSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDataExportsForOrgSecurity$outboundSchema: z.ZodMiniType<
  ListDataExportsForOrgSecurity$Outbound,
  ListDataExportsForOrgSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDataExportsForOrgSecurityToJSON(
  listDataExportsForOrgSecurity: ListDataExportsForOrgSecurity,
): string {
  return JSON.stringify(
    ListDataExportsForOrgSecurity$outboundSchema.parse(
      listDataExportsForOrgSecurity,
    ),
  );
}

/** @internal */
export type ListDataExportsForOrgRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDataExportsForOrgRequest$outboundSchema: z.ZodMiniType<
  ListDataExportsForOrgRequest$Outbound,
  ListDataExportsForOrgRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listDataExportsForOrgRequestToJSON(
  listDataExportsForOrgRequest: ListDataExportsForOrgRequest,
): string {
  return JSON.stringify(
    ListDataExportsForOrgRequest$outboundSchema.parse(
      listDataExportsForOrgRequest,
    ),
  );
}
